"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function OurCorePhilosophy() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: specsRef,
    isVisible: specsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const specs = [{
    value: "12",
    unit: "MERCATI",
    label: "PRESIDIO GLOBALE"
  }, {
    value: "80",
    unit: "%",
    label: "TASSO DI CONVERSIONE B2B"
  }, {
    value: "0",
    unit: "",
    label: "SITI VETRINA PRODOTTI"
  }, {
    value: "100",
    unit: "M€",
    label: "EXPORT GENERATO"
  }];
  const paragraphs = ["Non siamo una web agency tradizionale. Siamo un'azienda di Intelligence Digitale e Sviluppo Mercati. Costruiamo infrastrutture digitali ad altissima conversione per il B2B e guidiamo l'espansione commerciale delle aziende italiane sui mercati internazionali con precisione chirurgica.", "Ogni progetto fonde tre elementi asimmetrici: architettura web avanzata, neuromarketing applicato alle vendite e reale intelligenza logistica. Non creiamo semplici siti, ma motori di ricerca partner che abbattono le barriere linguistiche e culturali per trovare distributori reali.", "Se cercate un partner per il rifacimento del sito web aziendale che sia una macchina per la lead generation estera, la nostra metodologia 'Black Label' è progettata per i CEO che esigono risultati misurabili e un vantaggio competitivo incolmabile."];
  return <section data-section-id="1735" id="our-core-philosophy" className="bg-background text-foreground py-32 md:py-44 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-4xl mx-auto">
        {}
        <div ref={headRef} className={`flex items-center justify-center gap-3 mb-12 md:mb-16 transition-all duration-700 ease-out ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
      }}>
          <span className="font-mono uppercase tracking-[0.2em] text-xs md:text-sm" style={{
          color: "var(--primary)"
        }}>
            § 01 / ASIMMETRIA
          </span>
          <span className="inline-block w-2 h-2" style={{
          backgroundColor: "var(--primary)"
        }} aria-hidden="true" />
          <span className="font-mono uppercase tracking-[0.2em] text-xs md:text-sm" style={{
          color: "var(--primary)"
        }}>
            IL NOSTRO METODO
          </span>
        </div>

        {}
        <h2 className={`font-default font-bold uppercase text-left text-foreground transition-all duration-700 ease-out ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        fontSize: "clamp(2.5rem, 5.5vw, 5.25rem)",
        lineHeight: "1.1",
        letterSpacing: "-0.02em",
        transitionDelay: "120ms",
        transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
      }}>
          L'INTELLIGENZA DEVE
          <br />
          ESSERE{" "}
          <span className="relative inline-block whitespace-nowrap">
            <span className="relative z-10">STRATEGICA</span>
            <svg className="absolute left-[-4%] top-1/2 -translate-y-1/2 pointer-events-none" width="108%" height="120%" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              <line x1="0" y1="80" x2="100" y2="20" stroke="var(--primary)" strokeWidth="4" style={{
              strokeDasharray: 200,
              strokeDashoffset: headVisible ? 0 : 200,
              transition: "stroke-dashoffset 800ms cubic-bezier(0.16, 1, 0.3, 1) 700ms"
            }} />
            </svg>
          </span>
          .
          <br />
          DATI PRIMA DI TUTTO.
          <br />
          RISULTATI PERCHÉ
          <br />
          SIAMO CHIRURGICI.
        </h2>

        {}
        <div className={`mt-14 md:mt-20 mb-12 md:mb-16 flex items-center transition-opacity duration-500 ${headVisible ? "opacity-100" : "opacity-0"}`} style={{
        transitionDelay: "400ms"
      }}>
          <div className="flex-1 h-px" style={{
          backgroundColor: "var(--border)"
        }} />
          <div className="w-1.5 h-1.5" style={{
          backgroundColor: "var(--primary)"
        }} aria-hidden="true" />
        </div>

        {}
        <div ref={bodyRef} className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          <div className={`md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 transition-all duration-700 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
        }}>
            {paragraphs.map((p, i) => <p data-index={i} key={i} className={`font-default text-base md:text-lg leading-[1.6] text-foreground/85 ${i === 0 ? "md:col-span-1" : i === 1 ? "md:col-span-1" : "md:col-span-2 max-w-3xl"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                {p}
              </p>)}
          </div>
        </div>

        {}
        <div ref={specsRef} className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-3">
          {specs.map((spec, i) => <div data-index={i} key={i} className={`relative p-6 md:p-7 transition-all duration-600 ease-out rounded-md ${specsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          backgroundColor: "var(--card)",
          transitionDelay: `${i * 100}ms`,
          transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
          boxShadow: "var(--shadow-sm)"
        }}>
              {}
              <div className="absolute top-0 left-0 right-0 h-px" style={{
            backgroundColor: "var(--primary)"
          }} aria-hidden="true" />
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="font-default font-bold uppercase text-foreground leading-none" style={{
              fontSize: "clamp(2rem, 3.5vw, 3rem)",
              letterSpacing: "-0.02em"
            }}>
                  {spec.value}
                </span>
                {spec.unit && <span className="font-mono uppercase text-xs tracking-[0.12em]" style={{
              color: "var(--primary)"
            }}>
                    {spec.unit}
                  </span>}
              </div>
              <div className="mt-4 font-mono uppercase text-[11px] md:text-xs tracking-[0.14em] text-muted-foreground">
                {spec.label}
              </div>
            </div>)}
        </div>

        {}
        <div className={`mt-16 md:mt-20 flex justify-center transition-all duration-700 ease-out ${specsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: "400ms",
        transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
      }}>
          <Link to="/HomePage" className="group inline-flex items-center gap-2 font-default font-bold uppercase tracking-[0.06em] text-sm md:text-base" style={{
          color: "var(--primary)"
        }}>
            <span className="relative">
              <span className="relative z-10">SCOPRI IL NOSTRO METODO</span>
              <span className="absolute left-0 right-0 bottom-[2px] h-[2px] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out" style={{
              backgroundColor: "var(--primary)"
            }} aria-hidden="true" />
            </span>
            <span className="inline-block transition-transform duration-300 ease-out group-hover:translate-x-1.5" aria-hidden="true">
              →
            </span>
          </Link>
        </div>
      </div>
    </section>;
}